const convertCentToDecimal = (serverCentAmount) => {
  return serverCentAmount ? serverCentAmount / 100 : void 0;
};
export {
  convertCentToDecimal
};
//# sourceMappingURL=convert-cent-to-decimal.js.map
